document.addEventListener('DOMContentLoaded', () => {
  const debounce = (fn, delay) => {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const toggleButtons = document.querySelectorAll('.js-rated-table-toggle');
  const dropdowns = document.querySelectorAll('.js-rated-table-dropdown');
  const icons = document.querySelectorAll('.icon-table-dropdown-toggle');

  toggleButtons.forEach((toggle) => {
    const handleClick = (e) => {
      e.stopPropagation();
      const ratingBlock = toggle.closest('.rating');
      const dropdown = ratingBlock.querySelector('.js-rated-table-dropdown');
      const icon = toggle.querySelector('.icon-table-dropdown-toggle');
      const isOpen = dropdown.classList.contains('is-open');

      dropdowns.forEach((el) => {
        if (el !== dropdown) {
          el.classList.remove('is-open');
          el.style.maxHeight = '0px';
        }
      });

      icons.forEach((el) => {
        if (el !== icon) {
          el.classList.remove('rotate');
        }
      });

      if (isOpen) {
        dropdown.classList.remove('is-open');
        dropdown.style.maxHeight = '0px';
        icon.classList.remove('rotate');
      } else {
        dropdown.classList.add('is-open');
        dropdown.style.maxHeight = dropdown.scrollHeight + 'px';
        icon.classList.add('rotate');
      }
    };

    toggle.addEventListener('click', debounce(handleClick, 200));
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('.rating')) {
      dropdowns.forEach((el) => {
        el.classList.remove('is-open');
        el.style.maxHeight = '0px';
      });
      icons.forEach((el) => el.classList.remove('rotate'));
    }
  });

  const sortButtons = document.querySelectorAll('.sort-btn');
  sortButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const table = btn.closest('.campaigns-table');
      const rows = Array.from(table.querySelectorAll('.table-row'));
      const getScore = (el) => parseFloat(el.dataset.score);
      const [first, second] = rows;
      const isCurrentlyAsc =
        first && second && getScore(first) < getScore(second);
      const asc = !isCurrentlyAsc;

      const sorted = rows.sort((a, b) => {
        const aScore = getScore(a);
        const bScore = getScore(b);
        return asc ? aScore - bScore : bScore - aScore;
      });

      sorted.forEach((row) => table.appendChild(row));
    });
  });

  // 🎨 Automatická detekce barvy z HEX a přidání CSS třídy
  function hexToHsl(hex) {
    hex = hex.replace('#', '');
    const bigint = parseInt(hex, 16);
    const r = ((bigint >> 16) & 255) / 255;
    const g = ((bigint >> 8) & 255) / 255;
    const b = (bigint & 255) / 255;

    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h = 0;
    const d = max - min;
    const l = (max + min) / 2;
    const s = d === 0 ? 0 : d / (1 - Math.abs(2 * l - 1));

    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }

    h = Math.round(h * 60);
    return { h, s, l };
  }

  function getColorNameFromHue(hue) {
    if (hue >= 0 && hue < 30) return 'red';
    if (hue >= 30 && hue < 90) return 'yellow';
    if (hue >= 90 && hue < 150) return 'green';
    if (hue >= 150 && hue < 270) return 'blue';
    if (hue >= 270 && hue < 330) return 'purple';
    return 'red';
  }

  document.querySelectorAll('.category-header').forEach((el) => {
    const hex = el.dataset.color.replace('#', '');
    if (!hex || hex.length !== 6) return;

    const { h } = hexToHsl(hex);
    const colorName = getColorNameFromHue(h);
    el.classList.add(`category-header--${colorName}`);
  });
});
